import Stripe from "stripe";
import { CancelSubscriptionBody } from "../../pages/api/cancel_subscription";
import { EmulateSubscriptionPlanBody } from "../../pages/api/emulate_subscription_plan";
import { InitiateCheckoutSessionBody } from "../../pages/api/initiate_checkout_session";
import { UpdateOrderCheckoutBody } from "../../pages/api/update_order_checkout";
import { UpdateSubscriptionPlanBody } from "../../pages/api/update_subscription_plan";
import { fetchPostJSON } from "../../utils/api-helpers";
import { InitiateSubscriptionSessionBody } from "../../pages/api/initiate_subscription_session";

/**
 * Generate the session id to checkout with stripe
 */
export const generateCheckoutSessionId = async (
  args: InitiateCheckoutSessionBody
): Promise<Stripe.Checkout.Session | { statusCode: 500; message: string }> => {
  return await fetchPostJSON("/api/initiate_checkout_session", args);
};

/**
 * Generate the session id to SUBSCRIBE ONLY with stripe
 */
export const generateSubscriptionSessionId = async (
  args: InitiateSubscriptionSessionBody
): Promise<Stripe.Checkout.Session | { statusCode: 500; message: string }> => {
  return await fetchPostJSON("/api/initiate_subscription_session", args);
};

/**
 * Create an updated order for a existing subscription the session id to checkout with stripe
 */
export const updateOrderCheckout = async (
  args: UpdateOrderCheckoutBody
): Promise<Stripe.Checkout.Session | { statusCode: 500; message: string }> => {
  return await fetchPostJSON("/api/update_order_checkout", args);
};
export const cancelSubscription = async (
  args: CancelSubscriptionBody
): Promise<any | { statusCode: 500; message: string }> => {
  return await fetchPostJSON("/api/cancel_subscription", args);
};

export const emulateSubscriptionPlan = async (
  args: EmulateSubscriptionPlanBody
): Promise<Stripe.Invoice> => {
  return await fetchPostJSON("/api/emulate_subscription_plan", args);
};

/**
 * Update a users subscription plan
 */
export const updateSubscriptionPlan = async (
  args: UpdateSubscriptionPlanBody
): Promise<Stripe.Subscription> => {
  return await fetchPostJSON("/api/update_subscription_plan", args);
};
